export default __webpack_public_path__ + "static/media/map.2a1daf5c.png";